import {ApiClientService, EntityApiService} from '@dofleini/security';
import {authentication} from '@/settings';

class SpaceApiService extends EntityApiService {

    getCurrent = () => {
      return ApiClientService.get(this.getPath('/current'));
    }
}

export default new SpaceApiService(`${authentication.path}/api/spaces`);
